import { Component } from 'react';
import { withTranslation } from 'react-i18next';

class LinkAccount extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;

        return (
            <div className="padding-x-20">
                <div id="onboarding-general-settings">
                    <div className="mt-10">
                        {this.props.available_accounts?.map((item, i) => (
                            <div key={i} className="onboarding-step-1">
                                <div className="d-flex align-items-center">
                                    <div
                                        className="onboarding-step-1-img"
                                        style={{
                                            backgroundImage: `url(${item.account_picture})`,
                                        }}
                                    ></div>
                                    <span className="linked-users-span">{item.account_email}</span>
                                </div>
                                <div className="d-flex align-items-center onboarding-step-1-button">
                                    <button
                                        className="button button-filled button-primary width-sm btn ml-10 mt-0"
                                        title="Add Domain"
                                        onClick={() => this.props.selectAccount(item)}
                                    >
                                        {t('onboarding.step_1.button_name')}
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(LinkAccount);
